<template>
  <div class="header">
    <div class="content">
      <router-link class="logo" to="/">
        <img src="https://cdn-static-web.moycp.com/nfyk/image/logo.png" alt/>
      </router-link>
      <div class="button" v-if="!haveLogin">
        <div class="login" @click="showPopTab(0)">登录</div>
        <div class="register" @click="showPopTab(1)">注册</div>
      </div>
      <div class="list" v-if="haveLogin">
        <div class="sculpture">
          <span>{{name}}</span>
          <div class="headPic">
            <img v-if="photo" :src="photo" alt/>
            <img v-else src="https://cdn-static-web.moycp.com/nfyk/image/headPic.png" alt/>
          </div>
        </div>
        <ul class="menuPage">
          <router-link :to="{path: '/record',query:{id: 1}}" class="menuPage-li" tag="li">个人中心</router-link>
          <router-link :to="{path: '/record',query:{id: 2}}" class="menuPage-li" tag="li">报考记录</router-link>
          <router-link :to="{path: '/record',query:{id: 4}}" class="menuPage-li" tag="li">毕业论文</router-link>
          <router-link :to="{path: '/record',query:{id: 5}}" class="menuPage-li" tag="li">学位论文</router-link>
          <router-link :to="{path: '/record',query:{id: 6}}" class="menuPage-li" tag="li">培训记录</router-link>
          <li class="menuPage-li" @click="exitLogin">退出登录</li>
        </ul>
      </div>
    </div>
    <!-- 登录注册弹窗 -->
    <el-dialog
      :visible.sync="showPop"
      width="500px"
      :before-close="handleClose"
      :close-on-click-modal="false"
      class="dialog"
    >
      <div class="dialog-head">
        <span :class="{'line': activeTab == 0}" @click="changeTab(0)">登录</span>
        <span :class="{'line': activeTab == 1}" @click="changeTab(1)">注册</span>
      </div>
      <!-- 登录框 -->
      <el-form
        v-if="activeTab == 0"
        :model="ruleForm"
        ref="ruleForm"
        class="dialog-content"
        label-width="60px"
      >
        <el-form-item label="账号" prop="account">
          <el-input v-model="ruleForm.account" placeholder="手机号或身份证号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <!-- 注册框 -->
      <el-form
        v-if="(activeTab == 1)&&(haveRegisted == false)"
        :model="registForm"
        ref="registForm"
        class="dialog-content"
        label-width="60px"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="registForm.name" placeholder="请输入您的姓名"></el-input>
          <div class="errorTips" v-if="registRules.nameNotEmpty == false">{{registRules.nameTips}}</div>
        </el-form-item>
        <div class="gender">
          <span>性别</span>
          <div
            class="gender-box"
            :class="{'gender-choose': isMale === 1}"
            @click="changeGender(1)"
          >男
          </div>
          <div
            class="gender-box"
            :class="{'gender-choose': isMale === 0}"
            @click="changeGender(0)"
          >女
          </div>
          <div
            class="errorTips"
            style="margin-top: 5px"
            v-if="registRules.genderNotEmpty == false"
          >请填写性别
          </div>
        </div>
        <el-form-item label="身份证号" prop="IDCard">
          <el-input v-model="registForm.IDCard" placeholder="请输入您的身份证号"></el-input>
          <div
            class="errorTips"
            v-if="registRules.IDCardNotEmpty == false"
          >{{registRules.IDCardTips}}
          </div>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="registForm.phone" placeholder="手机号将作为登录账号"></el-input>
          <div class="errorTips" v-if="registRules.phoneNotEmpty == false">{{registRules.phoneTips}}</div>
        </el-form-item>
        <el-form-item label="验证码" prop="identifyCode" class="identifyCode">
          <el-input v-model="registForm.identifyCode" placeholder="请输入验证码"></el-input>
          <span @click="openRegistCodePop" class="obtain-code">{{identifyContent}}</span>
          <div
            class="errorTips"
            v-if="registRules.identifyCodeNotEmpty == false"
          >{{registRules.identifyCodeTips}}
          </div>
        </el-form-item>
        <el-form-item label="QQ号" prop="qq">
          <el-input v-model="registForm.qq" placeholder="请输入您的qq号"></el-input>
          <div class="errorTips" v-if="registRules.qqNotEmpty == false">{{registRules.qqTips}}</div>
        </el-form-item>
        <el-form-item label="密码" prop="cypher">
          <el-input
            v-model="registForm.cypher"
            placeholder="密码为8-16位大小写字母、数字、特殊符号的组合"
            show-password
          ></el-input>
          <div
            class="errorTips"
            v-if="registRules.cypherNotEmpty == false"
            style="width: 320px"
          >{{registRules.cypherTips}}
          </div>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirm">
          <el-input v-model="registForm.confirm" placeholder="请再次输入密码" show-password></el-input>
          <div class="errorTips" v-if="registRules.confirmNotEmpty == false">两次密码输入不一致，请重新输入</div>
        </el-form-item>
        <!-- 上传图片 -->
        <div class="picture">
          <span>照片</span>
          <el-upload
            class="upload-file"
            action="https://up-z2.qiniup.com"
            :data="uploadToken"
            :show-file-list="false"
            :auto-upload="autoUpload"
            :before-upload="beforeAvatarUpload"
            :on-success="handleAvatarSuccess"
            accept=".jpg, .jpeg, .png"
          >
            <img v-if="imageUrl" :src="imageUrl" class="avatar"/>
            <i v-if="imageUrl" class="deletePic" @click.stop="imageUrl = ''"></i>
            <div v-else class="fill">
              <i class="addPic"></i>
            </div>
          </el-upload>
          <div class="limit">
            <p>照片要求：</p>
            <p>宽：114像素&nbsp;&nbsp;高：156像素</p>
            <p>大小：小于5MB</p>
          </div>
        </div>
        <div
          class="errorTips"
          style="margin-top: 5px"
          v-if="registRules.photoNotEmpty == false"
        >请上传图片
        </div>
      </el-form>
      <div
        v-if="(activeTab == 1)&&(haveRegisted == false)"
        class="button-change button-fixed"
        style="margin-top: 20px"
        @click="handleSignUp"
      >立即注册
      </div>
      <!-- 注册成功图 -->
      <div class="success" v-if="(activeTab == 1) && (haveRegisted == true)">
        <div class="success-Pic">
          <img src="https://cdn-static-web.moycp.com/nfyk/image/register.png" alt/>
        </div>
        <span>注册成功</span>
      </div>
      <!-- 忘记密码框 -->
      <el-form v-if="activeTab == 2" :model="forgetForm" ref="forgetForm" class="dialog-content" label-width="60px">
        <el-form-item label="手机号" prop="account">
          <el-input v-model="forgetForm.account" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="identifyCode" class="identifyCode">
          <el-input v-model="forgetForm.identifyCode" placeholder="请输入验证码"></el-input>
          <span @click="openForgetCodePop" class="obtain-code">{{identifyContent}}</span>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="forgetForm.password"
            placeholder="密码为8-16位大小写字母、数字、特殊符号的组合"
            show-password
          ></el-input>
          <div
            class="errorTips"
            v-if="forgetRules.passwordVaild == false"
            style="width: 320px">{{forgetRules.passwordTips}}
          </div>
        </el-form-item>
      </el-form>
      <!-- 登录错误提示 -->
      <div class="error" v-if="isError">
        <i></i>
        <!--        <span>账号或密码有误，请重新输入</span>-->
        <span>{{errorMsg}}</span>
      </div>
      <!-- 按钮 -->
      <div
        v-if="activeTab == 0"
        class="button"
        :class="{'button-active': (ruleForm.account&&ruleForm.password)}"
        @click="openLoginCodePop"
      >登录
      </div>
      <!-- <div v-if="(activeTab == 1)&&(haveRegisted == false)" class="button-change button-fixed" @click="handleSignUp">立即注册</div> -->
      <div
        v-if="(activeTab == 1)&&(haveRegisted == true)"
        class="button-change"
        @click="activeTab = 0"
      >去登录
      </div>
      <div v-if="activeTab == 2" class="button"
           :class="{'button-active': (forgetForm.account&&forgetForm.identifyCode&&forgetForm.password&&forgetRules.passwordVaild)}"
           @click="handleForget">确认修改
      </div>
      <!-- 忘记密码 -->
      <div class="forget" v-if="activeTab == 0">
        <span class="presentation" @click="changeTab(1)">未注册用户请先完成注册</span>
        <span @click="changeTab(2)">忘记密码</span>
        <!--        <el-tooltip class="item" effect="dark" content="请联系管理员重置密码" placement="top-end">-->
        <!--          <i></i>-->
        <!--        </el-tooltip>-->
      </div>
    </el-dialog>
    <!-- 获取验证码弹窗 -->
    <identify-Code :showPop="showCodePop" @closePop="closeCodePop" :key="timer"></identify-Code>
  </div>
</template>

<script>
  import {getToken, setToken, removeToken} from "@/utils/auth";
  import {strategy} from "@/utils/checkRules";
  import {hex_md5} from "@/utils/passwordEncrypt";
  import identifyCode from "./identifyCode";
  import storage from "../utils/storage";

  export default {
    name: "Header",
    components: {
      identifyCode,
    },
    props: {
      showPop: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        activeTab: 0,
        isActive: false, //控制登录按钮状态
        isError: false, //控制登录错误信息提示
        errorMsg: '',
        haveRegisted: false, //判断是否注册成功
        haveLogin: false, //判断是否已经登录
        mustModifyPassword: false, //判断是否必须修改密码
        showCodePop: false, //展示获取验证码弹窗
        showCodeCallBack: null, //动态验证码回调方法
        ruleForm: {
          account: "",
          password: "",
        },
        registForm: {
          name: "",
          IDCard: "",
          phone: "",
          identifyCode: "",
          qq: "",
          cypher: "",
          confirm: "",
        },
        forgetForm: {
          account: '',
          identifyCode: '',
          password: '',
        },
        // 注册学生数据
        registRules: {
          nameNotEmpty: true,
          nameTips: "", //姓名错误信息
          genderNotEmpty: true, //性别的错误状态
          IDCardNotEmpty: true,
          IDCardTips: "", //身份证号错误信息
          phoneNotEmpty: true,
          phoneTips: "", //手机号错误信息
          qqNotEmpty: true,
          qqTips: "", //qq号的错误信息
          cypherNotEmpty: true,
          cypherTips: "", //密码的错误信息
          confirmNotEmpty: true, //确认密码的错误状态
          identifyCodeNotEmpty: true, //验证码的错误状态
          identifyCodeTips: "", //验证码的错误信息
          photoNotEmpty: true, //头像的错误状态
        },
        forgetRules: {
          passwordVaild: true,
          passwordTips: "", //密码的错误信息
        },
        identifyContent: "获取验证码", //验证码的内容
        flag: 0, //判断验证弹窗是否成功关闭
        totalTime: 60, //验证码的时间
        timer: "", //让验证码弹窗再次渲染
        imageUrl: "", //注册头像
        isMale: 2, //区分1男性0女性
        name: "", //登录成功用户名
        photo: "", //登录成功用户头像
        //上传头像部分的参数
        autoUpload: true,
        uploadToken: {
          name: "",
          key: "",
          token: "",
        }, // 上传凭证
        fileList: [],
        prifix: "", //文件名添加此前缀
        domain: "", //文件展示需拼接此前缀，协议同当前协议，防止跨域
      };
    },
    mounted() {
      //判断登录状态
      if (getToken()) {
        this.haveLogin = true;
      } else {
        this.haveLogin = false;
      }
      this.name = localStorage.getItem("Name");
      this.photo = localStorage.getItem("Photo");
      //获取七牛上传参数
      this.getQiNiuToken();
    },
    methods: {
      // 校验是否需要修改密码
      checkPassword(cb) {
        this.mustModifyPassword = storage.get("mustModifyPassword") || false;
        console.log("this.mustModifyPassword is " + this.mustModifyPassword);
        if (this.haveLogin && this.mustModifyPassword) {
          // 修改密码
          this.$message.error("密码过于简单，请先修改密码");
          cb && cb();
        }
      },
      //弹窗的关闭按钮
      handleClose() {
        this.$emit("closePop");
        //清空登录输入、提示信息
        this.isError = false;
        this.ruleForm = {};
        //清空注册输入、提示信息
        this.registForm.name = "";
        this.registForm.IDCard = "";
        this.isMale = 2;
        this.registForm.phone = "";
        this.registForm.identifyCode = "";
        this.registForm.qq = "";
        this.registForm.cypher = "";
        this.registForm.confirm = "";
        this.imageUrl = "";
        this.registRules.nameNotEmpty = true;
        this.registRules.genderNotEmpty = true;
        this.registRules.IDCardNotEmpty = true;
        this.registRules.phoneNotEmpty = true;
        this.registRules.qqNotEmpty = true;
        this.registRules.cypherNotEmpty = true;
        this.registRules.confirmNotEmpty = true;
      },
      //弹窗内切换登录注册
      changeTab(val) {
        this.activeTab = val;
      },
      //上传图片成功
      handleAvatarSuccess(res) {
        this.imageUrl = "https://" + this.domain + "/" + res.key;
      },
      //上传前的校验
      beforeAvatarUpload(file) {
        this.uploadToken.name = this.prifix + file.name;
        this.uploadToken.key = this.prifix + Date.now() + "/" + file.name;
        // const isJPG = file.type === 'image/jpeg'
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";
        const isLt5M = file.size / 1024 / 1024 < 5;

        if (!isJPG) {
          this.$message.error("仅支持上传jpg、jpeg、png格式的图片");
        }
        if (!isLt5M) {
          this.$message.error("上传头像图片大小不能超过 5MB!");
        }
        return isJPG && isLt5M;
        // return isLt5M
      },
      //首页切换登录注册
      showPopTab(val) {
        this.$emit("openPop");
        this.activeTab = val;
      },
      changeGender(val) {
        this.isMale = val;
      },
      //登录接口
      handleLogin() {
        if (
          this.flag == 1 &&
          this.ruleForm.account != "" &&
          this.ruleForm.password != ""
        ) {
          this.$request
            .login({
              account: this.ruleForm.account,
              pwd: hex_md5(this.ruleForm.password),
            })
            .then((res) => {
              //登录成功
              this.isError = false;
              if (res.retcode === "0") {
                setToken(res.data.stuToken);
                this.haveLogin = true;
                this.$emit("closePop");
                //获取用户信息
                this.$request.getUserInfo().then((res) => {
                  this.name = res.data.name;
                  this.photo = res.data.photo;
                  //存储信息
                  localStorage.setItem("Name", res.data.name);
                  localStorage.setItem("Photo", res.data.photo);
                  localStorage.setItem("Phone", res.data.phone);
                  localStorage.setItem("Gender", res.data.gender);
                  localStorage.setItem(
                    "Admission",
                    res.data.identificationCardCode
                  );
                });
                this.mustModifyPassword = !strategy.pwdCheck(
                  this.ruleForm.password
                ).status;
                storage.set("mustModifyPassword", this.mustModifyPassword);
                if (this.mustModifyPassword) {
                  // 修改密码
                  this.$message.error("登录成功，密码过于简单，请先修改密码");
                  this.$router.push({path: "/record?id=1"}).catch(() => {
                  });
                } else {
                  // 成功登录
                  this.$message({
                    message: "登录成功",
                    type: "success",
                  });
                }
              } else {
                //登录失败
                this.isError = true;
                this.errorMsg = res.retdesc;
              }
            });
        }
      },
      //忘记密码
      handleForget() {
        //密码的校验
        this.forgetRules.passwordVaild = strategy.pwdCheck(
          this.forgetForm.password
        ).status;
        this.forgetRules.passwordTips = strategy.pwdCheck(
          this.forgetForm.password,
          "",
          "密码为8-16位大小写字母、数字、特殊符号的组合",
          "请输入密码"
        ).msg;
        if (
          this.forgetForm.account != "" &&
          this.forgetForm.identifyCode != "" &&
          this.forgetRules.passwordVaild
        ) {
          this.$request
            .forgetPwd({
              phone: this.forgetForm.account,
              checkCode: this.forgetForm.identifyCode,
              pwd: hex_md5(this.forgetForm.password),
            })
            .then((res) => {
              if (res.retcode === "0") {
                //修改成功
                this.isError = false;
                setToken(res.data.stuToken);
                this.haveLogin = true;
                this.$emit("closePop");
                //获取用户信息
                this.$request.getUserInfo().then((res) => {
                  this.name = res.data.name;
                  this.photo = res.data.photo;
                  //存储信息
                  localStorage.setItem("Name", res.data.name);
                  localStorage.setItem("Photo", res.data.photo);
                  localStorage.setItem("Phone", res.data.phone);
                  localStorage.setItem("Gender", res.data.gender);
                  localStorage.setItem(
                    "Admission",
                    res.data.identificationCardCode
                  );
                });
                // 成功修改
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
              } else {
                //修改失败
                this.isError = true;
                this.errorMsg = res.retdesc;
              }
            });
        }
      },
      //注册接口
      handleSignUp() {
        //姓名的校验
        this.registRules.nameNotEmpty = strategy.nameCheck(
          this.registForm.name,
          5
        ).status;
        this.registRules.nameTips = strategy.nameCheck(
          this.registForm.name,
          5,
          "",
          "姓名最多5个字符",
          "请输入姓名"
        ).msg;
        //性别的校验
        if (this.isMale === 0 || this.isMale === 1) {
          this.registRules.genderNotEmpty = true;
        } else {
          this.registRules.genderNotEmpty = false;
        }
        //身份证号的校验
        this.registRules.IDCardNotEmpty = strategy.idCardCodeCheck(
          this.registForm.IDCard
        ).status;
        this.registRules.IDCardTips = strategy.idCardCodeCheck(
          this.registForm.IDCard,
          "",
          "身份证号格式有误",
          "请输入身份证号"
        ).msg;
        //手机号的校验
        this.registRules.phoneNotEmpty = strategy.phoneCheck(
          this.registForm.phone
        ).status;
        this.registRules.phoneTips = strategy.phoneCheck(
          this.registForm.phone,
          "",
          "手机号格式有误",
          "请输入手机号"
        ).msg;
        //验证码的校验
        if (this.registForm.identifyCode === "") {
          this.registRules.identifyCodeNotEmpty = false;
          this.registRules.identifyCodeTips = "请输入验证码";
        } else {
          this.registRules.identifyCodeNotEmpty = true;
        }
        //qq号的校验
        this.registRules.qqNotEmpty = strategy.qqCheck(
          this.registForm.qq,
          20
        ).status;
        this.registRules.qqTips = strategy.qqCheck(
          this.registForm.qq,
          20,
          "",
          "QQ号只能输入数字",
          "QQ号最多20位"
        ).msg;
        //密码的校验
        this.registRules.cypherNotEmpty = strategy.pwdCheck(
          this.registForm.cypher
        ).status;
        this.registRules.cypherTips = strategy.pwdCheck(
          this.registForm.cypher,
          "",
          "密码为8-16位大小写字母、数字、特殊符号的组合",
          "请输入密码"
        ).msg;
        // 确认密码的校验
        if (this.registForm.confirm !== this.registForm.cypher) {
          this.registRules.confirmNotEmpty = false;
        } else {
          this.registRules.confirmNotEmpty = true;
        }
        //头像的校验
        if (this.imageUrl === "") {
          this.registRules.photoNotEmpty = false;
        } else {
          this.registRules.photoNotEmpty = true;
        }
        //校验通过
        if (
          this.registRules.nameNotEmpty &&
          this.registRules.genderNotEmpty &&
          this.registRules.IDCardNotEmpty &&
          this.registRules.phoneNotEmpty &&
          this.registRules.identifyCodeNotEmpty &&
          this.registRules.qqNotEmpty &&
          this.registRules.cypherNotEmpty &&
          this.registRules.confirmNotEmpty &&
          this.registRules.photoNotEmpty
        ) {
          this.$request
            .signUp({
              name: this.registForm.name,
              gender: this.isMale == 1 ? "男" : "女",
              identificationCardCode: this.registForm.IDCard,
              phone: this.registForm.phone,
              qqNum: this.registForm.qq,
              checkCode: this.registForm.identifyCode,
              pwd: hex_md5(this.registForm.cypher),
              portrait: this.imageUrl,
            })
            .then((res) => {
              if (res.retcode === "0") {
                //注册成功
                this.haveRegisted = true;
              } else if (res.retcode == "00003") {
                //身份证号已存在的错误信息
                this.registRules.IDCardNotEmpty = false;
                this.registRules.IDCardTips = res.retdesc;
              } else if (res.retcode == "00004") {
                //手机号已存在的错误信息
                this.registRules.phoneNotEmpty = false;
                this.registRules.phoneTips = res.retdesc;
              } else {
                //验证码的错误信息
                this.registRules.identifyCodeNotEmpty = false;
                this.registRules.identifyCodeTips = res.retdesc;
              }
            });
        }
      },
      //退出登录
      exitLogin() {
        removeToken();
        this.haveLogin = false;
        this.mustModifyPassword = false;
        storage.remove("mustModifyPassword");
        // 删除个人信息
        localStorage.removeItem("Name");
        localStorage.removeItem("Photo");
        localStorage.removeItem("Phone");
        localStorage.removeItem("Gender");
        localStorage.removeItem("Admission");
        this.$router.push({path: "/"}).catch(() => {
        });
      },
      //获取七牛上传参数
      getQiNiuToken() {
        this.$request.getUploadToken({}).then((res) => {
          if (res.retcode === "0") {
            this.uploadToken.token = res.data.uploadToken;
            this.prifix = res.data.prifix;
            this.domain = res.data.domain;
          }
        });
      },
      //获取验证码
      getCheckCode() {
        if (this.flag == 1) {
          //通过人工校验
          let clock = window.setInterval(() => {
            if (this.totalTime >= 1) {
              this.totalTime--;
              this.identifyContent = this.totalTime + "s后重新获取";
            }
            if (this.totalTime == 0) {
              this.identifyContent = "获取验证码";
              //清空计时器
              clearTimeout(clock);
            }
          }, 1000);
          this.$request
            .getCheckCode({
              phone: this.registForm.phone,
            })
            .then((res) => {
              if (res.retcode === "0") {
                //发送验证码
              } else {
                //错误验证码提示
                this.registRules.identifyCodeNotEmpty = false;
                this.registRules.identifyCodeTips = res.retdesc;
              }
            });
        } else {
          this.identifyContent = "获取验证码";
        }
        this.totalTime = 60;
      },
      //获取忘记密码验证码
      getForgetCheckCode() {
        if (this.flag == 1) {
          //通过人工校验
          let clock = window.setInterval(() => {
            if (this.totalTime >= 1) {
              this.totalTime--
              this.identifyContent = this.totalTime + 's后重新获取'
            }
            if (this.totalTime == 0) {
              this.identifyContent = '获取验证码'
              //清空计时器
              clearTimeout(clock)
            }
          }, 1000)
          this.$request
            .getForgetCheckCode({
              phone: this.forgetForm.account,
            })
            .then((res) => {
              if (res.retcode === '0') {
                //发送验证码
              } else {
                //错误验证码提示
                this.registRules.identifyCodeNotEmpty = false
                this.registRules.identifyCodeTips = res.retdesc
              }
            })
        } else {
          this.identifyContent = '获取验证码'
        }
        this.totalTime = 60
      },
      //打开登录验证码弹窗
      openLoginCodePop() {
        //先通过对手机号的校验才可获取验证码
        let accountCheck = strategy.isNotEmpty(this.ruleForm.account).status;
        let passwordCheck = strategy.isNotEmpty(this.ruleForm.password).status;
        //校验通过
        if (accountCheck && passwordCheck) {
          this.timer = new Date().getTime();
          this.showCodePop = true;
          this.showCodeCallBack = this.handleLogin;
        } else {
          this.showCodePop = false;
        }
      },
      // 登录
      login() {
      },
      //打开注册验证码弹窗
      openRegistCodePop() {
        //先通过对手机号的校验才可获取验证码
        this.registRules.phoneNotEmpty = strategy.phoneCheck(
          this.registForm.phone
        ).status;
        this.registRules.phoneTips = strategy.phoneCheck(
          this.registForm.phone,
          "",
          "手机号格式有误",
          "请输入手机号"
        ).msg;
        //校验通过
        if (
          this.identifyContent == "获取验证码" &&
          this.registRules.phoneNotEmpty
        ) {
          this.timer = new Date().getTime();
          this.showCodePop = true;
          this.showCodeCallBack = this.getCheckCode;
        } else {
          this.showCodePop = false;
        }
      },
      //打开忘记密码验证码弹窗
      openForgetCodePop() {
        //先通过对手机号的校验才可获取验证码
        let accountCheck = strategy.isNotEmpty(this.forgetForm.account).status
        //校验通过
        if (accountCheck && this.identifyContent == "获取验证码") {
          this.timer = new Date().getTime()
          this.showCodePop = true
          this.showCodeCallBack = this.getForgetCheckCode
        } else {
          this.showCodePop = false
        }
      },
      //关闭验证码弹窗,并判断是否通过验证
      closeCodePop(val) {
        this.flag = val;
        this.showCodePop = false;
        this.showCodeCallBack && this.showCodeCallBack();
        this.flag = 0;
        this.showCodeCallBack = null;
      },
    },
  };
</script>

<style lang="less" scoped>
  .header {
    height: 118px;
    background: url("https://cdn-static-web.moycp.com/nfyk/image/header.png") center no-repeat;
    background-size: cover;

    .content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo {
        width: 360px;
        height: 110px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .button {
        display: flex;
        align-items: center;
        text-align: center;
        line-height: 40px;

        .login {
          width: 102px;
          height: 40px;
          background: #ffffff;
          border-radius: 4px;
          font-size: 16px;
          color: #096cb8;
          cursor: pointer;
        }

        .register {
          width: 102px;
          height: 40px;
          margin-left: 16px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          border: 1px solid #ffffff;
          font-size: 16px;
          color: #ffffff;
          cursor: pointer;
        }
      }

      .list {
        width: 140px;
        height: 100px;
        line-height: 100px;
        z-index: 1000;

        &:hover {
          .menuPage {
            display: block;
          }
        }

        .sculpture {
          display: flex;
          align-items: center;
          justify-content: center;

          span {
            font-size: 16px;
            color: #ffffff;
          }

          .headPic {
            margin-left: 10px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .menuPage {
          display: none;
          margin-top: -20px;
          text-align: center;
          background: #ffffff;
          border-radius: 4px;

          .menuPage-li {
            width: 140px;
            height: 38px;
            line-height: 38px;
            font-size: 16px;
            color: #666666;
            cursor: pointer;

            &:hover {
              color: #096cb8;
            }

            &:nth-child(1),
            &:nth-child(2),
            &:nth-child(3),
            &:nth-child(4) {
              margin: 0 auto;
              width: 100px;
              border-bottom: 1px solid #efefef;
            }

            &:nth-child(5) {
              border-bottom: 4px solid #efefef;
            }
          }
        }
      }
    }

    .dialog {
      text-align: center;

      .dialog-head {
        span {
          font-size: 22px;
          font-weight: 500;
          color: #333333;
          margin: 0 13px;
          cursor: pointer;
        }

        .line {
          position: relative;

          &:after {
            content: "";
            position: absolute;
            width: 18px;
            height: 4px;
            bottom: -5px;
            left: 10px;
            background: #096cb8;
            border-radius: 2px;
          }
        }
      }

      .dialog-content {
        margin-top: 32px;
        max-height: 470px;
        overflow: auto;
        position: relative;

        .errorTips {
          width: 210px;
          text-align: left;
          margin-left: 90px;
          font-size: 14px;
          color: #d35f5f;
          height: 19px;
          line-height: 19px;
        }

        .gender {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 15px;

          span {
            margin-left: 33px;
          }

          .gender-box {
            margin-left: 26px;
            width: 48px;
            height: 38px;
            line-height: 38px;
            background: #f5f7fb;
            border-radius: 4px;
            font-size: 14px;
            color: #c4c9d5;
            border: 1px solid #f9f9f9;
            cursor: pointer;
          }

          .gender-box:nth-child(3) {
            margin-left: 10px;
          }

          .gender-choose {
            color: #333333;
          }
        }

        .identifyCode {
          position: relative;

          .obtain-code {
            position: absolute;
            right: 35px;
          }
        }

        .picture {
          display: flex;

          span {
            margin-left: 33px;
          }

          .upload-file {
            margin-left: 28px;
            width: 114px;
            height: 156px;
            background: #f5f7fb;
            border-radius: 4px;
            line-height: 170px;
            border: 1px solid #dcdfe6;
            position: relative;

            .avatar {
              width: 114px;
              height: 156px;
              display: block;
            }

            .deletePic {
              position: absolute;
              right: 0;
              top: 0;
              display: inline-block;
              width: 20px;
              height: 20px;
              background: url("https://cdn-static-web.moycp.com/nfyk/image/delete.png") center no-repeat;
              background-size: contain;
            }

            .fill {
              width: 114px;
              height: 156px;
            }

            .addPic {
              display: inline-block;
              width: 30px;
              height: 31px;
              background: url("https://cdn-static-web.moycp.com/nfyk/image/upload.png") center no-repeat;
              background-size: contain;
            }
          }

          .limit {
            margin-top: 100px;
            margin-left: 12px;
            text-align: left;

            p {
              font-size: 12px;
              color: #a1a6b1;
              line-height: 1.5;
            }

            .anew {
              margin-top: 28px;
              font-size: 12px;
              font-weight: 500;
              color: #096cb8;
              cursor: pointer;
            }
          }
        }

        .button-fixed {
        }
      }

      .success {
        .success-Pic {
          margin: 80px auto 28px;
          width: 266px;
          height: 200px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        span {
          font-size: 22px;
          font-weight: 500;
          color: #333333;
        }
      }

      .error {
        margin: 0 auto;
        width: 400px;
        height: 40px;
        background: #fff4f3;
        border-radius: 4px;
        font-size: 14px;
        line-height: 40px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          display: inline-block;
          margin-right: 12px;
          width: 20px;
          height: 20px;
          background: url("https://cdn-static-web.moycp.com/nfyk/image/error.png") center no-repeat;
          background-size: contain;
        }
      }

      .button {
        margin: 30px auto 0;
        width: 400px;
        height: 45px;
        background: #cecece;
        border-radius: 4px;
        font-size: 16px;
        line-height: 45px;
        color: #fff;
        cursor: default;
      }

      .button-active {
        background: #096cb8;
      }

      .button-change {
        margin: 30px auto 0;
        width: 400px;
        height: 45px;
        background: #096cb8;
        border-radius: 4px;
        font-size: 16px;
        line-height: 45px;
        color: #fff;
        cursor: default;
      }

      .forget {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 10px 30px 0 0;

        .presentation {
          margin-right: 168px;
        }

        span {
          font-size: 14px;
          color: #999999;
        }

        i {
          display: inline-block;
          margin-left: 4px;
          width: 12px;
          height: 12px;
          background: url("https://cdn-static-web.moycp.com/nfyk/image/question.png") center no-repeat;
          background-size: contain;
        }
      }
    }
  }

  /deep/ .el-dialog__body {
    padding: 0 20px 30px;
  }

  /deep/ .el-input {
    width: 340px;
    height: 46px;

    .el-input__inner {
      background: #f5f7fb;
    }
  }

  /deep/ .el-form-item__label {
    padding: 0;
  }

  /deep/ .el-form-item__content {
    margin-bottom: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue